module.exports = require("./fr-BE");